import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import {Observable} from 'rxjs';

import {DistributionGroupService} from '../../../../services/distribution-group-service';
import {DistributionGroup} from '../../../../interfaces/distribution-group';


@Component({
    selector: 'app-header-distribution-group',
    templateUrl: './header-distribution-group.component.html',
    styleUrls: ['./header-distribution-group.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Eager
})

export class HeaderDistributionGroupComponent  {

    constructor(
        private distributionGroupService: DistributionGroupService
    ) {}

    get selectedDistributionGroup$(): Observable<DistributionGroup> {
        return this.distributionGroupService.selectedDistributionGroup;
    }
}
